import { useContext, useEffect, useState } from "react"
import { SideBarLabelD2, SideBarIconsD2 } from './style'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { FlexRow, NavigationMenuD2 } from "src/style"
import { useLocation } from "react-router-dom"

export const SidebarMenu: React.FC<any> = ({item}) => {
    const location = useLocation()
    const {showSideBar} = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState(false)

    useEffect(() => {
        if (item.path.includes(location.pathname)) {
            setIsHover(true)
        }
        else setIsHover(false)
    }, [location.pathname])

    const handleSideBarShow = async (e: any) => {
        if(window.matchMedia('(max-width: 770px)').matches) {
            await showSideBar(false)
        }
    }

    return (
        <NavigationMenuD2
            to={item?.path}
            onClick={(e) => handleSideBarShow(e)}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(item.path.includes(location.pathname))}
        >
            <FlexRow 
                gap='2' 
                height='4'
                leftPadding='1.3'
                bottomMargin='1'
            >
                {item.icon(isHover || location.pathname.includes(item.path))}
                <SideBarLabelD2>{item.title}</SideBarLabelD2>
            </FlexRow>
        </NavigationMenuD2>
    )
}